// Certificates Tour
// Building, cloning and issuing certificates and badges
// Selector policy: step 1 pins to the live-verified sidebar id (#sb_memberships); teaching steps are
// deliberate centered cards — no guessed element selectors.

export const certificatesTour = {
  id: 'certificates',
  name: 'Certificates Tour',
  displayName: 'Certify & Reward Completion',
  description: 'Building, cloning and issuing certificates and badges',
  estimatedDuration: '3 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: { animate: true, overlayOpacity: 0.75, smoothScroll: true, allowClose: true, showProgress: true },

  steps: [
    {
      element: '#sb_memberships',
      popover: {
        title: "🏅 Welcome to Certificates",
        description: `
          Certificates and badges reward completion — and every time a learner shares one, it advertises your program for you.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎨 Build the Design",
        description: `
          Lay out the certificate with your logo, signature, and **merge fields** for the recipient name, course, and completion date. Design it once and it serves every learner.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📋 Clone for Variants",
        description: `
          **Clone** an existing certificate to make a variant instead of rebuilding it — one per course or level. Cloning keeps the family visually consistent, which is what makes them look credible.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎖️ Badges for Milestones",
        description: `
          Badges are smaller credentials for individual achievements. Design them simple and high-contrast — they get displayed tiny, and an unreadable badge never gets shared.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "⚡ Issue Automatically",
        description: `
          Award on **course completion** automatically. Manual issuing is fine for judged achievements, but automatic is what keeps this a motivator instead of an admin chore.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "⏳ Expiration & Renewal",
        description: `
          Set an expiry for credentials that should be renewed, then automate a reminder before it lapses — helpful for the holder, and a natural renewal prompt for you.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 Credentials, Handled",
        description: `
          You can now:

✅ Design certificates with merge fields
✅ Clone for consistent variants
✅ Issue badges automatically on completion
✅ Manage expiry and renewal

**Next:** issue one to yourself and check how it renders.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
